import { FC, ReactNode, useRef, useState } from "react";
import "./style.scss";

interface CustomDescriptionPopUPProps {
  text: string;
  children: ReactNode;
}

type PopupPlacement = "bottom" | "left";

const CustomDescriptionPopUP: FC<CustomDescriptionPopUPProps> = ({ text, children }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [placement, setPlacement] = useState<PopupPlacement>("bottom");

  const updatePlacement = () => {
    const wrapper = wrapperRef.current;
    const content = contentRef.current;
    if (!wrapper || !content) return;

    // Measure while hidden so we can decide placement before visible paint.
    const previousDisplay = content.style.display;
    const previousVisibility = content.style.visibility;
    content.style.display = "block";
    content.style.visibility = "hidden";

    const wrapperRect = wrapper.getBoundingClientRect();
    const contentRect = content.getBoundingClientRect();
    const gap = 8;
    const viewportPadding = 8;

    content.style.display = previousDisplay;
    content.style.visibility = previousVisibility;

    const centeredRight = wrapperRect.left + wrapperRect.width / 2 + contentRect.width / 2;
    const centeredLeft = wrapperRect.left + wrapperRect.width / 2 - contentRect.width / 2;
    const wouldOverflowRight = centeredRight > window.innerWidth - viewportPadding;
    const wouldOverflowLeft = centeredLeft < viewportPadding;
    const wouldOverflowBottom =
      wrapperRect.bottom + gap + contentRect.height > window.innerHeight - viewportPadding;

    if (wouldOverflowRight || wouldOverflowBottom || wouldOverflowLeft) {
      const fitsLeft = wrapperRect.left - gap - contentRect.width >= viewportPadding;
      setPlacement(fitsLeft ? "left" : "bottom");
      return;
    }

    setPlacement("bottom");
  };

  return (
    <div
      className={`custom-description-popup placement-${placement}`}
      ref={wrapperRef}
      onMouseEnter={updatePlacement}
    >
      {children}
      <div className="custom-description-popup-content" ref={contentRef}>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default CustomDescriptionPopUP;
